import { useWsmProductSeriesCreateMutation } from "@dashboard/graphql";
import useNavigator from "@dashboard/hooks/useNavigator";
import useNotifier from "@dashboard/hooks/useNotifier";
import { commonMessages } from "@dashboard/intl";
import { getMutationState } from "@dashboard/misc";
import React from "react";
import { useIntl } from "react-intl";

import WsmSeriesDetailsPage from "../components/WsmSeriesDetailsPage/WsmSeriesDetailsPage";
import { useWsmAxisAttributes } from "../hooks/useWsmAxisAttributes";
import { useWsmBrands } from "../hooks/useWsmBrands";
import { sectionMessages } from "../messages";
import { wsmSeriesUrl } from "../urls";
import { emptySeriesFormData, getSeriesCreateInput } from "../utils";

export const WsmSeriesCreateView = () => {
  const intl = useIntl();
  const navigate = useNavigator();
  const notify = useNotifier();
  const { attributes, loading: attributesLoading } = useWsmAxisAttributes();
  const { brands } = useWsmBrands();
  const [createSeries, createSeriesOpts] = useWsmProductSeriesCreateMutation({
    onCompleted: result => {
      const series = result.wsmProductSeriesCreate?.series;

      if (series && !result.wsmProductSeriesCreate?.errors.length) {
        notify({ status: "success", text: intl.formatMessage(commonMessages.savedChanges) });
        navigate(wsmSeriesUrl(series.id));
      }
    },
  });
  const errors = createSeriesOpts.data?.wsmProductSeriesCreate?.errors ?? [];

  return (
    <WsmSeriesDetailsPage
      title={intl.formatMessage(sectionMessages.createSeriesTitle)}
      attributes={attributes}
      attributesLoading={attributesLoading}
      brands={brands}
      initialData={emptySeriesFormData()}
      errors={errors}
      disabled={createSeriesOpts.loading}
      saveButtonBarState={getMutationState(
        createSeriesOpts.called,
        createSeriesOpts.loading,
        errors,
      )}
      onSubmit={formData =>
        createSeries({ variables: { input: getSeriesCreateInput(formData) } })
      }
    />
  );
};

export default WsmSeriesCreateView;
